import { render, staticRenderFns } from "./IconCopy.vue?vue&type=template&id=4adf5b66&"
import script from "./IconCopy.vue?vue&type=script&lang=ts&"
export * from "./IconCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports